var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.667 15.0034C25.667 17.6751 24.2904 20.0434 22.167 21.5368L20.6037 24.9784C20.242 25.7601 19.192 25.9118 18.6437 25.2468L16.917 23.1701C14.747 23.1701 12.752 22.4351 11.2354 21.2101L11.9354 20.3818C17.3254 19.9734 21.5837 15.7034 21.5837 10.5001C21.5837 9.61344 21.4554 8.73844 21.222 7.89844C23.8704 9.29844 25.667 11.9584 25.667 15.0034Z",
    fill: "#FF9400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0166 7.08183C17.6516 4.28183 14.6066 2.3335 11.0833 2.3335C6.25325 2.3335 2.33325 5.98516 2.33325 10.5002C2.33325 13.1718 3.70992 15.5402 5.83325 17.0335L7.39659 20.4752C7.75825 21.2568 8.80825 21.3968 9.35659 20.7435L9.99825 19.9735L11.0833 18.6668C15.9133 18.6668 19.8333 15.0152 19.8333 10.5002C19.8333 9.27516 19.5416 8.12016 19.0166 7.08183ZM13.9999 11.3752H8.16658C7.68825 11.3752 7.29158 10.9785 7.29158 10.5002C7.29158 10.0218 7.68825 9.62516 8.16658 9.62516H13.9999C14.4783 9.62516 14.8749 10.0218 14.8749 10.5002C14.8749 10.9785 14.4783 11.3752 13.9999 11.3752Z",
    fill: "#FF9400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoMessages);
export default __webpack_public_path__ + "static/media/trvto_messages.e02e61ecab0c8299228c69fa0fc9ae70.svg";
export { ForwardRef as ReactComponent };